import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useCreateCustomerPaymentMethod } from 'src/features/paymentMethods/api/useCreateCustomerPaymentMethod';
import { LIST_CUSTOMER_PAYMENT_METHODS_RESOURCE } from 'src/features/paymentMethods/api/useListCustomerPaymentMethods';
import CustomerPaymentMethodFormModal from 'src/features/paymentMethods/components/forms/CustomerPaymentMethodFormModal';
import { paymentMethodsMessages } from 'src/features/paymentMethods/utils/messages';

interface CreateCustomerPaymentMethodFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateCustomerPaymentMethodFormModal<TData>({
    className,
    semantics,
}: CreateCustomerPaymentMethodFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateCustomerPaymentMethod({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_CUSTOMER_PAYMENT_METHODS_RESOURCE] });
            toast({
                title: formatMessage(paymentMethodsMessages.createCustomerPaymentMethodSuccess),
                description: formatMessage(paymentMethodsMessages.createCustomerPaymentMethodSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <CustomerPaymentMethodFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(paymentMethodsMessages.addCustomerPaymentMethodSubtitle)}
        />
    );
}

export default CreateCustomerPaymentMethodFormModal;
